var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.Auth.status === "logged"
        ? [
            _vm.$store.getters["userProperties"].system_settings
              .is_module_travel_service_enabled === 2 &&
            (_vm.$store.getters.hasPermission("travelOrder") ||
              _vm.$store.getters.hasPermission("travelOrderSelf"))
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/travel-service" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("format_list_numbered")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.travelOrders")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.hasPermissionForBookings
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/booking" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("event")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.bookings")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters["userProperties"].system_settings
              .is_module_delegation_enabled === 2
              ? _c(
                  "v-list-item",
                  {
                    class: {
                      "v-list-item--active":
                        _vm.$route.fullPath.includes("delegation") &&
                        !_vm.$route.fullPath.includes("delegation-info") &&
                        !_vm.$route.fullPath.includes("settings")
                    },
                    attrs: { to: "/delegation" }
                  },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("assignment")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.delegations")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.hasPermissionForAdmin
              ? _c(
                  "v-list-item",
                  {
                    class: {
                      "v-list-item--active": _vm.$route.fullPath.includes(
                        "/settings/"
                      )
                    },
                    attrs: { to: "/settings/users" }
                  },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("settings")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.administration")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.hasPermissionForInvoices
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/invoices" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("content_copy")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.invoices")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters["userProperties"].system_settings
              .is_module_delegation_enabled === 2
              ? _c(
                  "v-list-item",
                  {
                    attrs: {
                      to: "/report",
                      disabled: !_vm.$store.getters.hasPermission(
                        "reportDelegation"
                      )
                    }
                  },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("show_chart")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.reports")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters["userProperties"].system_settings
              .is_module_delegation_enabled === 2 &&
            _vm.$store.getters["userProperties"].system_settings
              .is_module_optima_enabled === 2
              ? _c(
                  "v-list-item",
                  {
                    attrs: {
                      to: "/optima",
                      disabled: !_vm.$store.getters.hasPermission(
                        "reportDelegation"
                      )
                    }
                  },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("extension")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.optima")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters["userProperties"].system_settings
              .is_module_delegation_enabled === 2
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/delegation-info" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("view_agenda")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.delegationInfo")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "v-list-item",
              { attrs: { to: "/profile/my-profile" } },
              [
                _c(
                  "v-list-item-action",
                  [_c("v-icon", [_vm._v("person_outline")])],
                  1
                ),
                _c("v-list-item-content", [
                  _vm._v(_vm._s(_vm.$t("global.menu.profileSettings")))
                ])
              ],
              1
            ),
            _vm.$store.getters["userProperties"].system_settings
              .is_module_travel_service_enabled === 2 ||
            _vm.$store.getters["userProperties"].system_settings
              .is_module_delegation_enabled === 2
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/substitutes" } },
                  [
                    _c(
                      "v-list-item-action",
                      [
                        _c(
                          "v-badge",
                          {
                            staticClass: "menu-badge",
                            attrs: {
                              color: "primary",
                              value:
                                _vm.countCanLoginAs != null &&
                                _vm.countCanLoginAs !== 0
                            }
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "badge" }, slot: "badge" },
                              [_vm._v(_vm._s(_vm.countCanLoginAs))]
                            ),
                            _c("v-icon", [_vm._v("people_outline")])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.userSubstitute")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.isLoggedAs
              ? _c(
                  "v-list-item",
                  { on: { click: _vm.loginBack } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("transfer_within_a_station")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v(_vm._s(_vm.$t("global.menu.loginBack")))
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
        : [
            _c(
              "v-list-item",
              { attrs: { to: "/login" } },
              [
                _c(
                  "v-list-item-action",
                  [_c("v-icon", [_vm._v("exit_to_app")])],
                  1
                ),
                _c("v-list-item-content", [
                  _vm._v(_vm._s(_vm.$t("global.logIn")))
                ])
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }